const labelValues = {
  terrainLabelValues: [
    { label: "Itä-Eurooppa", value: "MainlandEast" },
    { label: "Välimeri", value: "Mediterranean" },
    { label: "Länsi-Eurooppa", value: "MainlandWest" },
    { label: "Britteinsaaret", value: "Britain" },
    { label: "Pohjois-Eurooppa", value: "NorthEurope" },
    { label: "Kaikki maa-alueet", value: "AllTerrains" },
  ],
  routeLabelValues: [
    { label: "Itä-Eurooppa", value: "EastEuropeRoutes" },
    { label: "Välimeri", value: "MediterraneanRoutes" },
    { label: "Länsi-Eurooppa", value: "WestEuropeRoutes" },
    { label: "Espanja", value: "SpainRoutes" },
    { label: "Britteinsaaret", value: "BritainRoutes" },
    { label: "Pohjois-Eurooppa", value: "NorthEuropeRoutes" },
    { label: "Kaikki kauppareitit", value: "Routes" },
  ],
};

export default labelValues;
